import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ReportIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M7 1a4 4 0 0 0-4 4v13a1 1 0 0 0 2 0V5c0-1.1.9-2 2-2h6v5a1 1 0 0 0 1 1h5v11a1 1 0 0 1-1 1h-1v-4.2a1 1 0 1 0-2 0V21h-2v-6.6a1 1 0 1 0-2 0V21H9v-9.6a1 1 0 1 0-2 0V21H4a1 1 0 0 0 0 2h14a3 3 0 0 0 3-3V8a1 1 0 0 0-.3-.72L15 1.58A2 2 0 0 0 13.6 1H7Zm10.6 6L15 4.41V7h2.59Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default ReportIcon;
